import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BackButtonComponent } from '../back-button/back-button.component';
import { Location } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { CommonModule } from '@angular/common';
import { PasswordModule } from 'primeng/password';
import { LambdaService } from 'src/app/services/lambda.service';
import { MenuItem, MessageService } from 'primeng/api';
import { SplitButton } from 'primeng/splitbutton';
import { ToastModule } from 'primeng/toast';
import { Ripple } from 'primeng/ripple';
import { SelectModule} from 'primeng/select';
import { StoreSalesComponent } from '../store-sales/store-sales.component';


@Component({
  selector: 'app-store-details',
  imports: [BackButtonComponent, ButtonModule, InputTextModule, DropdownModule, FormsModule, CommonModule, PasswordModule, ToastModule, StoreSalesComponent, SelectModule],
  templateUrl: './store-details.component.html',
  styleUrl: './store-details.component.scss',
  providers: [MessageService]
})
export class StoreDetailsComponent {
  store: any = {}
  subscriptions: any = {}
  subscriptionsArr: { label: string, value: any }[] = [];
	loading = false;

  isEditing: boolean = false;
  showApiKey: boolean = false;
  showInfobipApiKey: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private location: Location,
		private lambdaService: LambdaService,
		private messageService: MessageService
  ) {}

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
		this.getShopData(id);
    this.loadSubscriptions();
    console.log("tienda id ",id);
  }

	getShopData(shopId: any){
		this.loading = true;
    this.lambdaService
    .getShopData(shopId)
    .then((data: any) => {
      this.store = data.info;
			console.log(this.store,"store")
		})
    .catch((error: Error) => {
      console.error(error);
    })
    .finally(() => {
      setTimeout(() => {
        this.loading = false;
      }, 500);
    });
  }

	saveStore() {
		this.loading = true;
    	// this.showSuccess();
		this.lambdaService.updateShopInfo(
			this.store.shopId,
			this.store.shopName,
			this.store.shopDomain,
			this.store.shopSubscriptionId,
			this.store.shopApiKey,
			this.store.infobip_api_key,
			this.store.infobip_sender,
			this.store.infobip_api_host_uri
		)
		.then((data: any) => {
			console.log(data,"store update");
      this.getShopData(this.store.shopId);
			this.showSuccess();
		})
    .catch((error: Error) => {
			console.error(error);
			this.showSuccess();
    })
    .finally(() => {
      setTimeout(() => {
        this.loading = false;
      }, 500);
    });
	}

  async loadSubscriptions(){
    this.loading = true;
    await this.lambdaService.getSubscriptions()
    .then((data:any) => {
      console.log("shops: ",data.data);
      this.subscriptions = data.data;
      this.subscriptionsArr = this.subscriptions.map((subscription: any) => ({
        label: subscription.shopSubscriptionName,
        value: subscription.shopSubscriptionId
      }));
    })
    .catch(error => {
      let errorMessage = 'Error al cargar las tiendas: ' + error;
      console.error(errorMessage);
    })
    .finally(()=>{
      setTimeout(() => {
        this.loading = false;
      }, 500);
    })
  }

	showSuccess() {
    console.log('success')
		this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Cambos guardados con éxito' });
	}

	showError() {
		this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error al guardar' });
	}

  toggleEdit() {
    this.isEditing = !this.isEditing;
  }
}
